import logo from './favicon.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <code>null !== empty</code>
        </p>
        <a
          className="App-link"
          href="https://www.stl-horizon.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Copyright &copy; {new Date().getFullYear()} Software Technologies Limited
        </a>
      </header>
    </div>
  );
}

export default App;
